/* eslint-disable react/prop-types */
import React from 'react';
import { TrophyOutlined } from '@ant-design/icons';

import styles from './RankBars.less';

/**
 * RankBars —— 排名统计图
 * ------------------------------------------------------------------
 * 「会员活跃 TOP」这类排行，用文字列表既看不出差距也占地方，改成
 * 名次 + 姓名 + 比例条 + 数值；前三名给奖杯徽标（金/银/铜）。
 *
 * 条长以 max 为基准；数值统一走 unit 后缀，右侧固定列宽保证多行对齐。
 *
 * @param items [{ key, label, value, unit?, sub? }]
 * @param max   条长基准，默认取最大值
 * @param top   前几名显示奖杯，默认 3
 */
const RankBars = (props) => {
  const { items = [], max, top = 3, emptyText = '暂无数据' } = props;

  if (!items.length) {
    return <div className={styles.empty}>{emptyText}</div>;
  }

  const maxValue =
    max || Math.max(...items.map((i) => Number(i.value) || 0)) || 1;

  return (
    <div className={styles.list}>
      {items.map((it, i) => {
        const rank = i + 1;
        const width = Math.max(4, ((Number(it.value) || 0) / maxValue) * 100);
        return (
          <div key={it.key || `${it.label}-${i}`} className={styles.row}>
            <span
              className={`${styles.rank} ${
                rank <= top ? `${styles.medal} ${styles[`medal${rank}`]}` : ''
              }`}
              title={rank <= top ? `第 ${rank} 名` : undefined}
            >
              {rank <= top ? <TrophyOutlined /> : rank}
            </span>

            {it.href ? (
              <a
                className={styles.name}
                href={it.href}
                target="_blank"
                rel="noreferrer"
                title="查看会员档案"
              >
                {it.label}
              </a>
            ) : (
              <span className={styles.name} title={it.label}>
                {it.label}
              </span>
            )}

            <span className={styles.track}>
              <span
                className={`${styles.bar} ${
                  rank <= top ? styles.barMedal : ''
                }`}
                style={{ width: `${width}%` }}
              />
            </span>

            <span className={styles.value}>
              <b>{it.value}</b>
              {it.unit && <i className={styles.unit}>{it.unit}</i>}
              {it.sub && <em className={styles.sub}>{it.sub}</em>}
            </span>
          </div>
        );
      })}
    </div>
  );
};

export default RankBars;
